<script setup>
    import { useScrollStore } from '@/stores/scrollStore';

    const storeScroll = useScrollStore();
</script>
<template>
    <section class="numbers section">
        <div class="numbers__scroll">            
            <div class="numbers__title title"><span class="title-border"> HOW </span> TO USE <span class="title-border">HOW</span> TO USE </div>
            <div class="numbers__title title"><span class="title-border">&nbsp;HOW </span> TO USE <span class="title-border">HOW</span> TO USE </div>          
        </div>
        <div class="container"> 
            <ul class="numbers__list" >
                <li class="numbers__item" data-animation-bottom>
                    <span class="numbers__number">1</span>
                    <div class="numbers__content">
                        <p>Оформите электронный или физический сертификат — онлайн или в клубе. </p>
                        <a href="##" @click="storeScroll.scrollToId('constructor')">Создать</a>
                    </div>
                </li>
                <li class="numbers__item" data-animation-bottom>
                    <span class="numbers__number">2</span>
                    <div class="numbers__content">
                        <p>Персонализируйте подарок:  добавьте подпись и пожелание.</p>
                    </div>
                </li>
                <li class="numbers__item" data-animation-bottom>
                    <span class="numbers__number">3</span>
                    <div class="numbers__content">
                        <p>Получатель активирует сертификат при посещении и пользуется выбранными услугами. <br> Добро пожаловать в The Rink Fitness!</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="numbers__logo" data-animation-left>
            <img loading='lazy' width="200" height="64" src="@/assets/img/icons/logo.svg" alt="логотип">
        </div>
    </section>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.numbers {
    position: relative;
    overflow: hidden;
    padding: 12rem 0 5rem;
    border-bottom: 1px solid var(--border-default-4);
    border-top: 1px solid var(--border-default-4);
    @media (max-width: vars.$m) {
        padding: 7rem 0;
    }
    @media (max-width: vars.$x480) {
        padding: 2.5rem 0 6.2rem;

    }
}
.numbers__scroll {
    display: flex;
    width: fit-content;
    animation: scroll 10s linear infinite;
    -webkit-transform-style: preserve-3d;
}

.numbers__title {
    text-wrap: nowrap;
    white-space: nowrap;
    -webkit-backface-visibility: hidden;
}
.numbers__logo {
    position: absolute;
    bottom: 16%;
    left: 15rem;
    opacity: .2;
    @media (max-width: vars.$t) {
        position: static;
        width: 19rem;
        margin-top: -1rem;
        margin-right: auto;
        margin-left: auto;
    }
}
.numbers__list {
    margin-top: 7.7rem;
    display: grid;
    @media (max-width: vars.$x480) {
        margin-top: 0rem;
    }
}
.numbers__item {    
    display: flex;
    align-items: center;
    gap: 4.8rem;
    @media (max-width: vars.$m) {
        display: grid;
        grid-template-columns: 20rem 1fr;
    }
    @media (max-width: vars.$x480) {
        grid-template-columns: 10rem 1fr;
    }
    @media (max-width: vars.$x425) {
        grid-template-columns: 6rem 1fr;
        gap: 1.2rem;
    }
    @media (max-width: vars.$x375) {
        gap: .8rem;
    }

    &:nth-child(1){
        padding-left: 17rem;
        transition-delay: .5s;
        @media (max-width: vars.$t) {
            padding-left: 8rem;
        }
        @media (max-width: vars.$m) {
            padding-left: 0;
        }
        .numbers__content {
            max-width: 65rem;
            padding-bottom: 6rem;
        }
    }
    &:nth-child(2){
        justify-self: center;        
        margin-top: -2rem;
        transition-delay: 1s;
        @media (max-width: vars.$t) {
            // margin-top: 0;
        }
        @media (max-width: vars.$m) {
            justify-self: start;
            
        }
        @media (max-width: vars.$x425) {
            margin-top: -8rem;
        }
        .numbers__content {
            max-width: 43rem;
        }
    }
    &:nth-child(3){
        justify-self: end;
        padding-right: 5rem;
        margin-top: -2rem;
        transition-delay: 1.5s;
        @media (max-width: vars.$t) {
            // margin-top: 0;
            padding-right: 0;
        }
        @media (max-width: vars.$m) {
            justify-self: start;
        }
        @media (max-width: vars.$x425) {
            margin-top: -9rem;
            
        }
        .numbers__content {
            max-width: 52rem;
        }
    }
}
.numbers__number {
    font-family: var(--third-family);
    font-weight: 400;
    font-size: 24.4rem;
    line-height: 1;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    opacity: .1;
    text-align: center;
    @media (max-width: vars.$x480) {
        font-size: 16rem;
        letter-spacing: 0.11em;
    }   
    @media (max-width: vars.$x425) {
        line-height: 185%;
        font-size: 11rem;
    }
}
.numbers__content {
    font-family: var(--second-family);
    font-weight: 400;
    font-size: 2.8rem;
    line-height: 160%;
    padding-bottom: 4rem;
    @media (max-width: vars.$x480) {
        font-size: 2rem;
        padding-bottom: 3rem;
    }
    @media (max-width: vars.$x425) {
        font-size: 1.4rem;
    }
    a {
        font-weight: 800;
        font-size: 2rem;
        line-height: 120%;
        text-transform: uppercase;
        border-bottom: 1px solid var(--system-fill-light);
        padding-bottom: 0.5rem;
        transition:  var(--transition) ease-in;
        @media (hover: hover){
            &:hover {
                border-bottom: 1px solid transparent;
            }
        }
        @media (max-width: vars.$x480) {
            font-size: 1.6rem;
            line-height: 150%;
        }
    }
}
@keyframes scroll {
    0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
</style>